import { SocketSubscription } from '@mode/shared/data-access-socket';
import { createAction, props } from '@ngrx/store';
import { CreateGoogleSheetProps } from '@mode/dataset/contract';
import { GoogleSheetRunPusherSuccessPayload } from '@mode/dataset/google/contract';

export const createGoogleSheetDataset = createAction(
  '[Dataset] CREATE_GOOGLE_SHEET_DATASET',
  props<CreateGoogleSheetProps>()
);

export const createGoogleSheetDatasetSuccess = createAction(
  '[Dataset] CREATE_GOOGLE_SHEET_DATASET_SUCCESS',
  props<{ reportRunToken: string; channelName: string }>()
);

export const createGoogleSheetDatasetFailed = createAction('[Dataset] CREATE_GOOGLE_SHEET_DATASET_FAILED');

export const googleSheetSocketConnectionSuccess = createAction(
  '[Dataset] CREATE_GOOGLE_SHEET_SOCKET_CONNECTION_SUCCESS',
  props<{
    reportRunToken: string;
    googleSheetSubscription: SocketSubscription<GoogleSheetRunPusherSuccessPayload>;
  }>()
);

export const ingestGoogleSheetEnqueued = createAction(
  '[Dataset] INGEST_GOOGLE_SHEET_ENQUEUED',
  props<{ reportRunToken: string }>()
);

export const ingestGoogleSheetInProgresss = createAction(
  '[Dataset] INGEST_GOOGLE_SHEET_IN_PROGRESS',
  props<{ token: string; progressToastId: number }>()
);

export const ingestGoogleSheetSuccess = createAction(
  '[Dataset] INGEST_GOOGLE_SHEET_SUCCESS',
  props<{ token: string; datasetToken: string; editDatasetLink: string }>()
);

export const afterIngestGoogleSheetSuccess = createAction(
  '[Dataset] AFTER_INGEST_GOOGLE_SHEET_SUCCESS',
  props<{ datasetToken: string }>()
);

export const ingestGoogleSheetFailed = createAction(
  '[Dataset] INGEST_GOOGLE_SHEET_FAILED',
  props<{ token: string; editDatasetLink: string }>()
);
